import { axios } from '@Root/API'

export const get = (engagementId, accreditationAimId) => {
	return axios.get(`student-engagement/${engagementId}/accreditation-aim/${accreditationAimId}`)
}
